import type { Ingredient, MeasureType } from '../types';

export function ingredientToString(ingredient: Ingredient): string {
	const imperail = metricToUS(ingredient.amount, ingredient.measure);

	let result: string = ingredient.amount + ' ';

	if (ingredient.measure !== 'unit') {
		result += ingredient.measure;

		if (ingredient.amount > 1) {
			result += 's';
		}

		result += ' ';
	}

	if (imperail.measure !== 'none') {
		result += '(' + +imperail.amount.toFixed(2) + ' ' + imperail.measure;
		if (imperail.amount > 1) {
			result += 's';
		}
		result += ') ';
	}

	result += ingredient.type;

	return result;
}

export function metricToUS(
	amount: number,
	type: MeasureType
): { amount: number; measure: MeasureType } {
	// Anything in US will return None as no conversion is needed

	switch (type) {
		case 'ml': {
			return { amount: amount / 240, measure: 'cup' };
		}
		case 'gm': {
			return { amount: amount / 450, measure: 'lb' };
		}
		case 'c': {
			const tempF = (amount * 9) / 5 + 32;
			return { amount: tempF, measure: 'f' };
		}
	}

	return { amount: -1, measure: 'none' };
}
